<!--
 * @Author: cn1994
 * @Date: 2023-08-21 18:16:34
 * @LastEditors: cn1994
 * @LastEditTime: 2024-06-04 11:18:16
 * @Description: 预览图组件入口，可以在此拆分数据以及区分设备
-->
<template>
  <div class="ls-mobile-preview-component" :style="bgWitdh">
    <phone
      v-if="curentRole == 'student'"
      :instInfo="instInfo"
      :userInfo="userInfo"
      :topConfig="topConfig"
      :leftConfig="leftConfig"
      :plateConfig="plateConfig"
      :role="curentRole"
    />
    <!-- 老师和管理员角色用新版组件 -->
    <manage-phone
      v-else
      :instInfo="instInfo"
      :userInfo="userInfo"
      :plateConfig="plateConfig"
      :role="curentRole"
      :currentTab="currentTab"
    />

  </div>
</template>

<script>
import phone from './phone.vue'
import managePhone from './manage_phone.vue'
import { leftNavConfig  } from './config'
import { useBaseStore } from "@/stores/base";
import { useUserStore } from "@/stores/user";
export default {
  components: {
    phone,
    managePhone
  },
  props: {
    appData: {
      type: Array,
      default: () => {
        return []
      }
    },
    curentRole: {
      type: String,
    },
    homeImageUrl: {
      type: String,
      default: () => {
        return 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/c65221c7eb5380ba8c44e7ccc7724235.png'
      }
    },
    currentTab: {
      type: String,
      default: 'teaching'
    }
  },
  
  data() {
    const baseStore = useBaseStore();
    const userStore = useUserStore()
    return {
      // 机构信息
      instInfo: {
        instLogo: baseStore.myProfile.adInst.logoUrl,
        instTitle: userStore.instTitle,
        subject: this.getCourseName(),
      },
      // 用户信息
      userInfo: {
        avatar: 'https://cdnws.51tyty.com/lstyty/file/2020/8/3/b6232baa6a864447869245fde24abdbd.png',
        name: '用户昵称',
        role: 'groupAdmin'
      },
      // 顶部菜单配置
      topConfig: [],
      // 左侧菜单配置
      leftConfig: leftNavConfig,
      // 板块配置
      plateConfig: []
    }
  },
  watch: {
    appData: function(val) {
      this.$nextTick(() => {
        this.init()
        this.setBackground()
      })
    },
    homeImageUrl: {
      immediate: true,
      handler: function(val) {
        if (val) {
          this.setBackground()
        }
      }
    }
  },
  computed: {
    bgWitdh() {
      let style = ''
      if (this.curentRole != 'student') {
        style = 'width: 750px;' 
      }
      return style
    }
  },
  methods: {
    init() {
      // 拆分顶部菜单配置
      if (this.curentRole == 'student') {
        // 学生角色顶部只能是功能入口
        // 并且是直接在板块内返回的
        let topFunction = this.appData.find(item => {
          return item.areaType == 'topFunction'
        })
        if (topFunction) {
          this.topConfig = topFunction.subassemblys
        }
      }
      
      // 拆分板块配置
      let plateConfig = []
      // 接口不处理排序，所以需要按写死顺序添加到配置变量内
      this.appData.map(item => {
        if (item.areaType != 'topFunction' && item.hasHide == 'false') {
          if (item.areaType == 'courseLearn') {
            item.subassemblys.unshift(
              {
                id: 10000,
                hasHide: 'false',
                moduleShapeType: 'achievement',
                logoUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/11/28/c8c9c7ac41d9f05fbe236a96e4850b48.png',
                subassemblyTitle: [
                  {
                    defaultTitle: '个人信息',
                    title: '个人信息',
                  }
                ]
              },
              {
                id: 10001,
                hasHide: 'false',
                moduleShapeType: 'horizontalMiniRectangle',
                logoUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/08/24/66d53cf061f1d02491dbfacb8093aded.png',
                subassemblyTitle: [
                  {
                    defaultTitle: '家长通',
                    title: '家长通',
                  }
                ]
              },
              {
                id: 10002,
                hasHide: 'false',
                moduleShapeType: 'horizontalMiniRectangle',
                logoUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/13/6f718ee5144899db9cc9c1976638d9f9.png',
                subassemblyTitle: [
                  {
                    defaultTitle: '课堂报告',
                    title: '课堂报告',
                  }
                ]
              },
              {
                id: 10003,
                hasHide: 'false',
                moduleShapeType: 'horizontalMiniRectangle',
                logoUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/08/24/ca68fc6845bab6a6b357c045f61835ce.png',
                subassemblyTitle: [
                  {
                    defaultTitle: '学习成就',
                    title: '学习成就',
                  }
                ]
              }
            )
          } else if (item.areaType == 'personShow') {
            item['subassemblys'] = []
            item['subassemblys'].push({
              id: 30001,
              hasHide: 'false',
              logoUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/10/10/45b2dfdbadec07e20b05c36b1c8a410a.png',
              moduleShapeType: 'personShow',
              subassemblyTitle: [
                {
                  defaultTitle: '个人秀场',
                  title: '个人秀场',
                }
              ]
            })
          } else if (item.areaType == 'syncStudy') {
            item['subassemblys'] = []
            item['subassemblys'].push({
              id: 30002,
              hasHide: 'false',
              logoUrl: 'https://cdnws.51tyty.com/lstyty/file/2024/03/12/7ec9a4c7a017f3bb7733066e13e234f3.png',
              moduleShapeType: 'syncStudy',
              subassemblyTitle: [
                {
                  defaultTitle: '同步学',
                  title: '同步学',
                }
              ]
            })
          } else if (item.areaType == 'stu_growthFootprint') {
            item['subassemblys'] = []
            item['subassemblys'].push({
              id: 30003,
              hasHide: 'false',
              logoUrl: 'https://cdnws.51tyty.com/lstyty/file/2024/03/21/adf5a583bbef0d00051ecdeb9f9efbbb.png',
              moduleShapeType: 'stu_growthFootprint',
              subassemblyTitle: [
                {
                  defaultTitle: '成长足迹',
                  title: '成长足迹',
                }
              ]
            })
          }
          let subassemblys = []
          if(item.subassemblys) {
            item.subassemblys.map(s => {
              if (s.hasHide == 'false') {
                subassemblys.push(s)
              }
            })
          }
          item.subassemblys = subassemblys
          if (item.hasOwnProperty('subassemblys') && item.subassemblys.length > 0) {
            plateConfig.push(item)
          }
        }
      })
      if (this.curentRole == 'admin') {
        // 管理员
        if (this.currentTab == 'teaching') {
          plateConfig[0]['hiddenTitle'] = true
        } else if (this.currentTab == 'manage') {
          plateConfig.map(m => m['hiddenTitle'] = true)
        } else if (this.currentTab == 'expand') {
          plateConfig[0]['hiddenTitle'] = true
        }
      } else if (this.curentRole == 'teacher') {
        if (this.currentTab == 'teaching') {
          plateConfig[0]['hiddenTitle'] = true
        } else if (this.currentTab == 'manage') {
          plateConfig.map(m => m['hiddenTitle'] = true)
        } else if (this.currentTab == 'expand') {
          plateConfig[0]['hiddenTitle'] = true
        }
      }
      this.plateConfig = plateConfig
    },
    setBackground() {
      let doms = document.querySelectorAll('.ls-mobile-preview-component')
      if (doms) {
        doms.forEach(item => {
          item.style.backgroundImage = `url(${this.homeImageUrl})`
        })
      }
    },
    // 获取当前学科名
    getCourseName(){
      const baseStore = useBaseStore();
      const userStore = useUserStore()
      let list = Array.isArray(baseStore.myProfile.schoolsAndCourses) ? baseStore.myProfile.schoolsAndCourses : [baseStore.myProfile.schoolsAndCourses];
      let courseName = baseStore.myProfile.courses && baseStore.myProfile.courses.length > 0 ? 
                        baseStore.myProfile.courses[0].courseName : userStore.courseName || '';
      list.map(item => {
        if (item.instId != userStore.instId) {
          if(item.courses) {
            item.courses.map(cItem => {
              if (cItem.instId == userStore.instId) {
                courseName = cItem.courseName
              }
            });
          }
        } else {
          courseName = item.courseName;
        }
      });

      return courseName;
    },
  }
}
</script>

<style lang="less" scoped>
.ls-mobile-preview-component {
  background-size: 100% 100%;
  // min-height: 375px;
  width: 100%;
  // max-width: 900px;
  backdrop-filter: blur(5px);
}
</style>